<!--
 * @Author:
 * @Description: 黑名单详情顶部信息组件
 * @Date: 2025-04-10 20:26:39
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/risk/components/add-blackList-item/details-topinfo.vue
-->
<template>
  <div class="details-topinfo" v-if="libInfo">
    <!-- 基本信息部分 -->
    <div class="info-header">
      <h2 class="info-header-title">{{ libInfo?.libAlias || '' }}</h2>
      <!-- :title="$t('message.risk.copy')" -->
      <div class="id-copy">
        ID: {{ libInfo?.id || '' }}
        <i class="el-icon-document-copy copy-icon" @click="copyId"></i>
      </div>
    </div>

    <div class="info-grid">
      <div class="info-item status">
        <span class="label">{{ $t('message.tableCommon.status') }}</span>
        <span :class="['value', +libInfo?.status === 1 ? ' info' : 'success']">
          {{ +libInfo?.status === 1 ? $t('message.common.disable') : $t('message.common.enable') }}

        </span>
      </div>
      <div class="info-item list-type">
        <span class="label">{{ $t('message.risk.listType') }}</span>
        <span class="value">{{ libInfo?.typeText || '' }}</span>
      </div>
      <div class="info-item apply-to">
        <span class="label">{{ $t('message.risk.addBlacklistdialog.applyTo') }}</span>
        <span class="value">{{ typeFilter(libInfo?.productType) }}</span>
      </div>
      <div class="info-item last-modified">
        <span class="label">{{ $t('message.risk.lastModifiedDate') }}</span>
        <span class="value">{{ libInfo?.updateTime || '' }}</span>
      </div>
    </div>

    <!-- 统计信息部分 -->
    <div class="summary-section">
      <h3 class="summary-title">{{ $t('message.risk.currentItemsSummary') }}</h3>
      <div class="summary-grid">
        <div class="summary-item total">
          <div class="summary-item-top total">
            <span class="icon"></span>
            <span class="label">{{ $t('message.risk.total') }}</span>
          </div>
          <div class="summary-item-bottom">
            {{ libInfo?.totalItems || 0 }}
          </div>
        </div>
        <div class="summary-item active">
          <div class="summary-item-top active">
            <span class="icon"> </span>
            <span class="label">{{ $t('message.common.enable') }}</span>
          </div>
          <div class="summary-item-bottom">
            {{ libInfo?.activeItems || 0 }}
          </div>
        </div>
        <div class="summary-item inactive">
          <div class="summary-item-top inactive">
            <span class="icon"></span>
            <span class="label">{{ $t('message.common.disable') }}</span>
          </div>
          <div class="summary-item-bottom">
            {{ libInfo?.inactiveItems || 0 }}
          </div>
        </div>
        <div class="summary-item expiring">
          <div class="summary-item-top expiring">
            <span class="icon"></span>
            <span class="label">{{ $t('message.risk.status.expiringSoon') }}</span>
          </div>
          <div class="summary-item-bottom">
            {{ libInfo?.expiringItems || 0 }}
          </div>
        </div>
        <div class="summary-item hit-rate">
          <div class="summary-item-top hit-rate">
            <span class="icon"> </span>
            <span class="label">{{ $t('message.risk.hitRate30Days') }}</span>
          </div>
          <div class="summary-item-bottom">
            <!-- 乘以100 保留两位小数 -->
            <span class="hit-rate-value">{{ ((libInfo?.hitRate || 0) * 100).toFixed(2) }}</span>
            <span class="hit-rate-percent">%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RULE_PRODUCT_TYPE_OPTIONS } from '@/views/risk/api/options';
export default {
  name: 'DetailsTopinfo',
  props: {
    libInfo: {
      type: Object,
      default: () => null,
    },

  },

  methods: {
    copyId() {
      this.$copyText(this.libInfo?.id).then(() => {
        this.$message.success('ID copied successfully');
      }).catch(() => {
        this.$message.error('Failed to copy ID');
      });
    },
    typeFilter(value) {
      return value ? this.$t(RULE_PRODUCT_TYPE_OPTIONS.find(item => item.value === value)?.label || '') : '';
    },
  },

};
</script>

<style scoped lang="scss">
.details-topinfo {
  padding: 0 24px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #EFEFF4;

  .info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;

    .info-header-title {

      font-weight: bold;
      font-size: 20px;
      color: #1A202C;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .id-copy {
      display: flex;
      align-items: center;

      font-weight: 400;
      font-size: 14px;
      color: #1A202C;
      line-height: 18px;
      text-align: right;
      font-style: normal;
      text-transform: none;

      .copy-icon {
        font-size: 8px;
        margin-left: 8px;
        cursor: pointer;
        color: #409EFF;
        font-size: 16px;
      }
    }
  }

  .info-grid {
    display: flex;
    align-content: center;
    justify-content: flex-start;
    border-top: 1px solid #EFEFF4;
    border-bottom: 1px solid #EFEFF4;
    padding: 16px 0;

    .info-item {
      border-right: 1px solid #EFEFF4;
      padding-left: 16px;

      &.status {
        width: 176px;

        .value {
          display: inline-block;
          background: #ECFDF3;
          border-radius: 20px 20px 20px 20px;
          padding: 4px 10px;
        }

        .success {
          color: #00B42A;
          background: #ECFDF3;
        }

        .info {
          color: #F53F3F;
          background: #FEF3F2;
        }
      }

      &.list-type {
        width: 176px;
      }

      &.apply-to {
        width: 176px;
      }

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        border-right: none;
      }

      .label {
        display: block;

        font-weight: 400;
        font-size: 14px;
        color: #667085;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 8px;
      }

      .value {
        display: block;

        font-weight: 400;
        font-size: 14px;
        color: #1A202C;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  .summary-section {
    .summary-title {
      font-weight: 400;
      font-size: 16px;
      color: #1A202C;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin: 16px 0;
    }

    .summary-grid {
      display: flex;
      justify-content: flex-start;
      padding-bottom: 24px;

      .summary-item {
        display: flex;
        flex-direction: column;
        align-items: left;
        border-right: 1px solid #EFEFF4;
        padding-left: 16px;
        width: 176px;

        &:last-child {
          border-right: none;
        }

        &:first-child {
          padding-left: 0;
        }

        &.hitRate {
          flex: 1;
        }

        .summary-item-top {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .icon {
            width: 12px;
            height: 12px;
            background: #8D98AF;
            border-radius: 2px 2px 2px 2px;
            margin-right: 8px;
          }

          .label {

            font-weight: 400;
            font-size: 14px;
            color: #667085;
            line-height: 18px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          &.total {
            .icon {
              background: #8D98AF;
            }
          }

          &.active {
            .icon {
              background: #00B42A;
            }
          }

          &.inactive {
            .icon {
              background: #F56C6C;
            }
          }

          &.expiring {
            .icon {
              margin-right: 6px;
              width: 18px;
              height: 18px;
              background: url('~@/assets/image/Error.png') no-repeat;
              background-size: 100% 100%;
            }
          }

          &.hit-rate {
            .icon {
              margin-right: 6px;
              width: 18px;
              height: 18px;
              background: url('~@/assets/image/Base.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }

        .summary-item-bottom {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-weight: bold;

          font-weight: bold;
          font-size: 20px;
          color: #1A202C;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-top: 12px;

          .hit-rate-percent {
            font-family: "Open Sans-Bold";
            font-weight: 700;
            font-size: 18px;
            color: #667085;
            line-height: 18px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
  }
}
</style>
